import WebServiceRequest from "../../Api/WebServiceRequest";

class AdGetRequest extends WebServiceRequest {
  constructor(context) {
    super(context);
  }
  setId(slug, id) {
    super.setTag(`${slug}/Get?id=` + id);
  }
}
export default AdGetRequest;
